import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  styled,
  CircularProgress,
} from "@mui/material";
import {
  CancelFormActionButton,
  PrimaryFormLoadingActionButton,
} from "../../Features/Table/GenericDraggableTable/TableStyles";
import { manageIotTesting } from "../../Api/IoTApi";

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    borderRadius: 8,
    width: "440px",
    maxWidth: "95%",
  },
}));

const FieldRow = ({ label, value }) => (
  <Box sx={{ display: "flex", mb: 1.5 }}>
    <Typography sx={{ width: 120, color: "#6B7280", fontSize: 13, fontWeight: 500, flexShrink: 0 }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: 13, color: "#111827", fontWeight: 400 }}>
      {value || "—"}
    </Typography>
  </Box>
);

const StatusAfterBadge = () => (
  <Box
    sx={{
      display: "inline-block",
      px: 1.5,
      py: 0.25,
      borderRadius: "12px",
      backgroundColor: "#FFF3CD",
      color: "#92400E",
      fontSize: 12,
      fontWeight: 500,
    }}
  >
    Under Testing
  </Box>
);

const StartTestingModal = ({ open, device, isRetest, onClose, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) {
      setError(null);
      setIsLoading(false);
    }
  }, [open]);

  const handleConfirm = async () => {
    setIsLoading(true);
    setError(null);
    const res = await manageIotTesting(device.imei, { action: "start" });
    setIsLoading(false);

    if (res?.responseStatus?.code === 200) {
      onSuccess(res.response?.data);
      onClose();
    } else {
      setError(res?.responseStatus?.msg || "Something went wrong.");
    }
  };

  const handleClose = () => {
    if (isLoading) return;
    setError(null);
    onClose();
  };

  if (!device) return null;

  return (
    <StyledDialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ pb: 1, fontSize: 15, fontWeight: 600 }}>
        {isRetest ? "Re-test IOT Device" : "Start IOT Testing"}
      </DialogTitle>
      <DialogContent sx={{ pt: "8px !important" }}>
        <FieldRow label="IMEI" value={device.imei} />
        <FieldRow label="MSISDN" value={device.msisdn} />
        <FieldRow label="SIM Number" value={device.simNumber} />
        <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
          <Typography sx={{ width: 120, color: "#6B7280", fontSize: 13, fontWeight: 500, flexShrink: 0 }}>
            Status after
          </Typography>
          <StatusAfterBadge />
        </Box>
        {error && (
          <Typography sx={{ mt: 2, color: "#DC2626", fontSize: 13 }}>{error}</Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <CancelFormActionButton onClick={handleClose} disabled={isLoading}>
          Cancel
        </CancelFormActionButton>
        <PrimaryFormLoadingActionButton onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? <CircularProgress size={16} color="inherit" /> : (isRetest ? "Re-test" : "Start Testing")}
        </PrimaryFormLoadingActionButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default StartTestingModal;
